<template>
<div class="battle">
  <iframe v-if="mobile" width="100%" frameborder="0" class="iframe" height="100%" marginheight="0" marginwidth="0"  :src="BATTLEHOST"/>
</div>
</template>
<script>
import { BATTLEHOST } from '../../utils/config'
import { get } from '../../utils/token'
import DDMixins from '../../minixs/ddMixis'
export default {
  mixins: [DDMixins],
  data () {
    return {
      BATTLEHOST,
      mobile: ''
    }
  },
  mounted () {
    this.mobile = get('mobile')
    this.BATTLEHOST = `${this.BATTLEHOST}?mobile=${this.mobile}`
  }
}
</script>
<style lang="scss" scoped>
.battle {
  height: 100vh;
  width: 100%;
  background: #fff;
  .iframe {
    border:none;
    border-style: none;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: hidden;
  }
}
</style>
